exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Consents{font-size:14px;margin-top:16px}.Consents-header{color:var(--text-primary);font-size:16px;font-weight:500;margin-top:32px;margin-bottom:16px}.Consents-header.error{color:var(--text-negative)}", ""]);

// exports
